/**
 * Player consent ledger — club admins (user list permission) and coaches.
 * Mirrors the backend `userCanManageClubMedia` check so coaches who collect
 * parental forms at the table can record and validate them.
 */
export function canAccessConsentLedger(user, hasPermission) {
  if (typeof hasPermission === "function" && hasPermission("USER_LIST_VIEW")) {
    return true;
  }
  if (!user) return false;
  const typeId = Number(user.type_user_id);
  if (typeId === 2 || typeId === 3) return true;
  if (user.hasCoachRole === true || user.hasAdminRole === true) return true;
  if (user.isCoach === true || user.isCoach === "true") return true;
  if (
    Array.isArray(user.all_role_names) &&
    user.all_role_names.some((n) => n === "Coach" || n === "Admin")
  ) {
    return true;
  }
  return false;
}
